export const getSplitExtraRows = (item = {}) =>
  (Array.isArray(item.extras) ? item.extras : [])
    .map((extra) => ({
      id: extra?.id ?? extra?.extra_id ?? null,
      name: String(extra?.name || extra?.extra_name || "Extra").trim() || "Extra",
      quantity: Number(extra?.quantity || 0),
      total: Number(extra?.total_price || 0),
    }))
    .filter((extra) => extra.quantity > 0);
